<template>
  <Info>
    Your free trial has expired. If you would like to<br />
    start a Seerist pilot or have questions about the product<br />
    please contact Seerist Sales by email info@seerist.com<br />
    or by telephone 800-674-8398.
  </Info>
</template>

<script>
export default {
  name: "TrialExpired",
  components: {
    Info: () => import("@/components/auth/Info"),
  },
};
</script>

<style scoped></style>
